module.exports = __webpack_public_path__ + "img/5b01c8b54eed37b368a0d22e166c475b.png";